import { Text } from "@volca/ui/components/ui/text";
import { count, listOf } from "@volca/ui/trades";
import type { GoalCoverage as Coverage } from "@/profitability/settings/types";

const compared = (sheet: Coverage) =>
  sheet.compared >= sheet.rows
    ? `${sheet.sheet} (all ${count(sheet.rows, "row")})`
    : `${sheet.sheet} (${sheet.compared} of ${count(sheet.rows, "row")}${sheet.sample ? ", a sample" : ""})`;

/** Every name, none folded into "and 2 others". */
const every = (names: string[]) => listOf(names, Math.max(names.length - 1, 2));

/**
 * Which sheets of the goal file the checks compared, and how many of their
 * rows; then the sheets they did not compare, so a match on the totals is
 * not read as a match on every job.
 */
export const GoalCoverage = ({
  coverage,
}: {
  coverage: Coverage[] | undefined;
}) => {
  if (!coverage?.length) return null;
  const read = coverage.filter((sheet) => sheet.compared > 0).map(compared);
  const unread = coverage
    .filter((sheet) => sheet.compared === 0)
    .map((sheet) => sheet.sheet);
  return (
    <Text variant="caption" tone="muted" data-testid="goal-coverage">
      {read.length > 0 && `Compared ${every(read)}.`}
      {read.length > 0 && unread.length > 0 && " "}
      {unread.length > 0 && `Not compared: ${every(unread)}.`}
    </Text>
  );
};
